import Location from 'app-location'
import * as yup from 'yup'
export const LoginInstitutionLocation = new Location('/login/:institution', {
  institution: yup.string(),
})
export const ChooseInstitutionLocation = new Location('/login', {
  institution: yup.string(),
})
